import { Box, CircularProgress } from '@mui/material';
import { indicatorWrapperStyles } from './styles';

export const ProgressIndicator = () => (
	<Box sx={indicatorWrapperStyles}>
		<CircularProgress sx={{ color: 'rgb(106, 176, 186)' }} />
	</Box>
);
